import React from "react"
import styled from "styled-components"

import Text from "../../common/components/Text"

import Check from "../images/Check"
import Close from "../images/Close"
import { fontWeight } from "buoy-theme"

const OuterContainer = styled.div`
  margin-bottom: 0;
`

const Container = styled.div`
  margin-top: 14px;
  display: flex;
  align-items: baseline;
`

const List = styled.ul`
  padding: 0;
  list-style-type: none;
  list-style-position: outside;
  
  li::before {
    content: ".";
    font-weight: ${fontWeight.medium};
    margin-right: 0.2rem;
    margin-left: -0.4rem;
    position: relative;
    top: -0.25em;
  }
`

const Item = Text.withComponent("li")

const DefaultReasons = ({ diagnosis }) => (
  <OuterContainer>
    {diagnosis.could_explain && (
      <Container>
        <Check color="primary" />
        <div>
          <Text color="primary" fontWeight="regular">
            Reasons for
          </Text>
          <List>
            <Item>{diagnosis.could_explain}</Item>
          </List>
        </div>
      </Container>
    )}
    {(diagnosis.cant_explain || diagnosis.usually_causes) && (
      <Container>
        <Close />
        <div>
          <Text fontWeight="regular" color="neutralDark">
            Reasons Against
          </Text>
          <List>
            {diagnosis.cant_explain && <Item>{diagnosis.cant_explain}</Item>}
            {diagnosis.usually_causes && (
              <Item>{diagnosis.usually_causes}</Item>
            )}
          </List>
        </div>
      </Container>
    )}
  </OuterContainer>
)

const Reasons = ({ diagnosis }) => {
  return <DefaultReasons diagnosis={diagnosis} />
}

export { Reasons as default }



// WEBPACK FOOTER //
// ./assets/completion/components/Reasons.js